import PropTypes from 'prop-types';
import { ActivityCompat } from '@/components';
import { CallConnectionScreen, CallConnectedScreen } from './components';
import { useCallScreenRouter } from '../viewmodels/useCallScreenRouter';
import '../styles/main.scss';

/**
 * Pure rendering component — zero business logic.
 * All pendingCall routing and call state come from useCallScreenRouter().
 */
export const CallScreenRouter = ({ children }) => {
   const { callScreenStatus, showOverlay } = useCallScreenRouter();

   return (
      <>
         <ActivityCompat active={!(showOverlay && callScreenStatus !== 'incoming')}>{children}</ActivityCompat>
         <div
            className="callScreenOverlay"
            style={{
               display: showOverlay ? 'block' : 'none',
            }}
         >
            {callScreenStatus === 'connected' ? <CallConnectedScreen /> : <CallConnectionScreen />}
         </div>
      </>
   );
};

CallScreenRouter.propTypes = {
   children: PropTypes.node.isRequired,
};
